import {Filtro} from './filtros/filtro';
import {FiltroIdentificador} from './filtros/filtro-identificador';
import {FiltroNome} from './filtros/filtro-nome';
import {FiltroVoid} from './filtros/filtro-void';
import {FiltroHorarioInicio} from './filtros/filtro-horario-inicio';
import {FiltroHorarioFim} from './filtros/filtro-horario-fim';
import {RotaVo} from '~model/vo/rota-vo';

export class FiltroFactory {

  static build(campo: string, comparador: string[]): Filtro<RotaVo> {
    if (campo === 'nome') {
      return new FiltroNome(comparador);
    }

    if (campo === 'identificador') {
      return new FiltroIdentificador(comparador);
    }

    if (campo === 'horarioInicio') {
      return new FiltroHorarioInicio(comparador);
    }

    if (campo === 'horarioFim') {
      return new FiltroHorarioFim(comparador);
    }

    return new FiltroVoid();
  }

}
